import Modal from "components/Modal";
import SingleSelect from "components/SingleSelect";
import Text from "components/Text";
import SocialHandle from "pages/AgencyInformation/components/SocialHandle";
import { FC } from "react";
import { BsInstagram, BsLink } from "react-icons/bs";
import { FaFacebookSquare, FaTwitterSquare } from "react-icons/fa";
import { HiBadgeCheck } from "react-icons/hi";
import { TbPencil } from "react-icons/tb";
import { useAppSelector } from "slice";
import theme from "theme";
import {
    BottomRow,
    ButtonSection,
    DetailSection,
    EditButton,
    FlexBetween,
    InstagramIcon,
    ListItem,
    ListSection,
    MileStone,
    MileStoneIcon,
    Name,
    ProfileHighlight,
    ShareIcon,
    ShareIcons,
    UserNameSection,
} from "./HighLight.styled";
import ImageSection from "./ImageSection";
import { useHighLight } from "./useHighLight";

export const HighLight: FC = () => {
    const {
        isModalOpen,
        availabilityStatus,
        handleEditProfile,
        toggleModal,
        handleChange,
    } = useHighLight();

    const {
        first_name,
        last_name,
        username,
        user_type,
        experiences,
        is_verified,
        social_links,
    } = useAppSelector((state) => state.user);

    return (
        <ProfileHighlight>
            <Modal isOpen={isModalOpen} onClose={toggleModal}>
                <Modal.Header>
                    <Text variant="heading3">Share</Text>
                </Modal.Header>
                <Modal.Content>
                    <ShareIcons>
                        <ShareIcon>
                            <BsInstagram />
                            <Text variant="label">Instagram</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <FaFacebookSquare />
                            <Text variant="label">Facebook</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <FaTwitterSquare />
                            <Text variant="label">Twitter</Text>
                        </ShareIcon>
                        <ShareIcon>
                            <BsLink />
                            <Text variant="label">Copy Link</Text>
                        </ShareIcon>
                    </ShareIcons>
                </Modal.Content>
            </Modal>
            <ImageSection />
            <DetailSection>
                {/* <InstagramIcon>
                    <BsInstagram color={theme.colors.grey.dark} />
                    <Text variant="label" fontWeight="500" color="#8A8A8A">
                        145k
                    </Text>
                </InstagramIcon> */}
                <InstagramIcon>
                    <SocialHandle socialHandles={social_links as any[]} />
                </InstagramIcon>
                <FlexBetween>
                    <UserNameSection>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                            }}
                        >
                            <Name variant="heading2">
                                {first_name} {last_name}
                            </Name>
                            {/* <ProBadge src={ProBadgeImage} alt="Pro Badge Image" /> */}
                            <Text
                                variant="body2"
                                color={theme.colors.grey.dark}
                                style={{
                                    display: "flex", // Enable flexbox
                                    alignItems: "center", // Vertically align items
                                    justifyContent: "space-between", // Space items if needed
                                    gap: "10px", // Add spacing between items
                                }}
                            >
                                {username}
                                {is_verified && (
                                    <MileStone
                                        left={"0"}
                                        isVerifiedMileStone={false}
                                        isComplete={false}
                                    >
                                        <MileStoneIcon>
                                            <HiBadgeCheck />
                                        </MileStoneIcon>
                                    </MileStone>
                                )}
                            </Text>
                        </div>
                    </UserNameSection>
                    <ButtonSection>
                        <EditButton>
                            <TbPencil
                                fontSize="18px"
                                onClick={handleEditProfile}
                            />
                        </EditButton>
                        {/* <ShareButton
                            type="button"
                            variant="filled"
                            onClick={handleShare}
                        >
                            <ShareButtonContent>
                                {linkCopied ? (
                                    <Text variant="button1">Link copied!</Text>
                                ) : (
                                    <>
                                        <BsShare color="fff" />
                                        <Text variant="button1">Share</Text>
                                    </>
                                )}
                            </ShareButtonContent>
                        </ShareButton> */}
                    </ButtonSection>
                </FlexBetween>
                <BottomRow>
                    <SingleSelect
                        label=""
                        value={availabilityStatus}
                        options={[
                            {
                                value: "Available",
                                label: "Available to work",
                                selected: true,
                            },
                            {
                                value: "Unavailable",
                                label: "unavailable to work",
                            },
                        ]}
                        onChange={handleChange}
                    />

                    {experiences && (
                        <ListSection>
                            <ListItem>
                                <Text
                                    variant="label"
                                    color={theme.colors.grey.primary}
                                    fontWeight="500"
                                >
                                    Type
                                </Text>
                                <Text variant="label" fontWeight="500">
                                    {user_type}
                                </Text>
                            </ListItem>
                            <ListItem>
                                <Text
                                    variant="label"
                                    color={theme.colors.grey.primary}
                                    fontWeight="500"
                                >
                                    Experience
                                </Text>
                                <Text variant="label" fontWeight="500">
                                    4 years
                                </Text>
                            </ListItem>
                        </ListSection>
                    )}
                </BottomRow>
            </DetailSection>
        </ProfileHighlight>
    );
};
